import { Consent } from '../../../../../dataTypes/type-consent';
import { DataService } from '../../../../../services/utilities/data.service';
import { HistoryLabelService } from '../../../../../services/consents-services/history-label.service';
import { SettingsService } from '../../../../../services/settings-service';

const _ = require('lodash');

const stateName = 'secondaryAdvancePrivacyView';

const historyTemplate = require('./templates/history-template.hbs');
const historyTemplate1 = require('./templates/history-template-1.hbs');

export default class SecondaryAdvanceHistoryViewController {
    static CONTROLLER_NAME = 'secondaryAdvanceHistoryViewController';
	private modalScope: any;
	private activeCategory: any;
    private categories: Consent.Category[];
    private consents: Consent.Consent[];
    private isVisible: boolean;
	private layoutParams: any;
	private settingsService: SettingsService;
	private utilityService: any;

	constructor(
		secondaryAdvanceViewController,
		modalScope,
		layoutParams,
		utilityService
	) {
		this.isVisible = false;
		this.layoutParams = layoutParams;

		this.modalScope = modalScope;
		this.settingsService = utilityService.settingsService;
		this.utilityService = utilityService;

		this.initActiveCategory();
    }

	private initActiveCategory() {
		this.activeCategory = _.find(this.categories, { active: true }) || {};
	}

	private setState() {
		this.modalScope.changeState(stateName);
	}

	private getHtml() {
        this.consents 
		this.utilityService.developmentLog('getting history HTML');
		let viewHTML: any = 'SECONDARY_BASIC_History_VIEW_DEFAULT';
		switch (this.layoutParams.modalView) {
		case 'corner-modal-template-12':
			viewHTML = historyTemplate1;
			break;
		default:
			viewHTML = historyTemplate;
			break;
		}

		// find out why it is taking too long: this.consentsService.prepareHistoryForCategoriesAndOptinConsent();
		const viewData = {
			history: HistoryLabelService.getFullHistoryList(DataService.consents),
            settings: this.settingsService.settings,
			consentTemplates: DataService.consentTemplates,
        };
		this.utilityService.developmentLog('got history HTML');
		return viewHTML(viewData);
	}

	public initHandling() {
		if (this.isVisible) {
			// empty block
		}
	}

	public set visible(_visible) {
		this.isVisible = _visible;
	}

	public get visible() {
		return this.isVisible;
	}

	public get htmlString(): string {
		if (this.isVisible) {
			return this.getHtml();
		}
		return '';
	}
}
